/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Renderable from "App/render/webgl/renderables/renderable";
import WebGLRenderGraph, {ERenderFiler} from "App/render/webgl/render_graph";
import Pass from "App/render/webgl/passes/pass";
import Factory from "App/render/webgl/renderables/factory";
import WebGLContext from "App/web_gl_context";
import IScene from "js_interface/src/scene_interface";
import RenderNode from "App/render/webgl/nodes/render_node";
import RenderOptionNode from "App/render/webgl/nodes/render_option_node";
import {EOutlinesStyle} from "js_interface/src/modules/render_settings/scene_render_settings_enums";

export default
class Material extends Renderable {

    public static TypeName: string = "Material";

    private _props: any = null;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aRenderNode: RenderNode) {
        super(aSceneAPI, aRenderGraph, aRenderNode);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aRenderNode: RenderNode): Material {
        return new Material(aSceneAPI, aRenderGraph, aRenderNode);
    }

    public setProperties(aProps: any) {
        this._props = aProps;
    }

    public render(aRenderPass: Pass) {
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();
        let state = aRenderPass.state;

        gl.uniform3fv(shader.uniformLocations["u_material.ambient"], this._props.ambientColor);
        gl.uniform3fv(shader.uniformLocations["u_material.diffuse"], this._props.diffuseColor);
        gl.uniform3fv(shader.uniformLocations["u_material.specular"], this._props.specularColor);
        gl.uniform3fv(shader.uniformLocations["u_material.emissive"], this._props.emissiveColor);
        gl.uniform1f(shader.uniformLocations["u_material.shininess"], this._props.shininess);

        if (!this._renderNode.getIsFromInternalModel()) {
            if (this._sceneAPI.renderSettingsModule.getForceGlobalTransparencyOverride()) {
                gl.uniform1f(shader.uniformLocations["u_material.transparency"], this._sceneAPI.renderSettingsModule.getForceGlobalTransparencyOverrideValue());
            } else if (!this._sceneAPI.renderSettingsModule.getElementTransparencyEnabled()) {
                gl.uniform1f(shader.uniformLocations["u_material.transparency"], 0.0);
            } else {
                gl.uniform1f(shader.uniformLocations["u_material.transparency"], this._props.transparency);
            }
        }
        else {
            gl.uniform1f(shader.uniformLocations["u_material.transparency"], this._props.transparency);
        }

        gl.uniform1i(shader.uniformLocations["u_material.shading"], this._props.shading);
        gl.uniform1f(shader.uniformLocations["u_material.alpha"], 1.0);
    }
}

Factory.register(Material);
